import api from './serviceApi'; // Import the axios instance

const customerApi = {
    /**
     * Fetch all customers with optional filters.
     * @param {Object} params - Query parameters such as `include`.
     * @returns {Promise<Object>} - The list of customers.
     */
    getAllCustomers: async (params = {}) => {
        try {
            const response = await api.get('/Customer', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching customers:', error);
            throw error;
        }
    },

    /**
     * Fetch a customer by its code.
     * @param {string} code - The code of the customer.
     * @param {Object} params - Query parameters such as `include`.
     * @returns {Promise<Object>} - The customer data.
     */
    getCustomerByCode: async (code, params = {}) => {
        try {
            const response = await api.get(`/Customer/${code}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching customer by code:', error);
            throw error;
        }
    },

        /**
     * Fetch a customer by its code.
     * @param {string} code - The code of the customer.
     * @param {Object} params - Query parameters such as `include`.
     * @returns {Promise<Object>} - The customer data.
     */
    getCustomerByUserCode: async (code, params = {}) => {
        try {
            const response = await api.get(`/Customer/GetByUser/${code}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching customer by code:', error);
            throw error;
        }
    },

    /**
     * Create a new customer.
     * @param {Object} customerData - The customer data to create.
     * @returns {Promise<Object>} - The created customer data.
     */
    createCustomer: async (customerData) => {
        try {
            const response = await api.post('/Customer', customerData);
            return response.data;
        } catch (error) {
            console.error('Error creating customer:', error);
            throw error;
        }
    },

    /**
     * Update an existing customer.
     * @param {Object} customerData - The customer data to update.
     * @returns {Promise<Object>} - The updated customer data.
     */
    updateCustomer: async (customerData) => {
        try {
            const response = await api.put('/Customer', customerData);
            return response.data;
        } catch (error) {
            console.error('Error updating customer:', error);
            throw error;
        }
    },

    /**
     * Delete a customer by its code.
     * @param {string} customerCode - The customer code to delete.
     * @returns {Promise<Object>} - The result of the deletion.
     */
    deleteCustomer: async (customerCode) => {
        try {
            const response = await api.delete('/Customer', {
                data: { code: customerCode },
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting customer:', error);
            throw error;
        }
    },

    /**
     * Export customers based on filters.
     * @param {Object} params - Query parameters such as `term`, `isActive`, etc.
     * @returns {Promise<Blob>} - The exported file data.
     */
    exportCustomers: async (params) => {
        try {
            const response = await api.get('/Customer/export', {
                params
            });
            return response.data;
        } catch (error) {
            console.error('Error exporting customers:', error);
            throw error;
        }
    },

    /**
     * Fetch a paginated list of customers with optional filters.
     * @param {Object} params - Query parameters such as `page`, `quantity`, `term`, etc.
     * @returns {Promise<Object>} - The paginated list of customers.
     */
    getCustomersPaginated: async (params) => {
        try {
            const response = await api.get('/Customer/pagged', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching paginated customers:', error);
            throw error;
        }
    },
};

export default customerApi;
